module.exports = __webpack_public_path__ + "img/13.eddbc5c2.jpg";